export function calculatePatientAgeYears(dateOfBirth?: string): number | null {
  if (!dateOfBirth) return null;
  const trimmed = dateOfBirth.trim();
  const ukMatch = trimmed.match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})$/);
  const dob = ukMatch
    ? new Date(Number(ukMatch[3]), Number(ukMatch[2]) - 1, Number(ukMatch[1]))
    : new Date(trimmed);
  if (isNaN(dob.getTime())) return null;

  const today = new Date();
  let age = today.getFullYear() - dob.getFullYear();
  const monthDiff = today.getMonth() - dob.getMonth();
  if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < dob.getDate())) {
    age--;
  }
  return Math.max(0, age);
}
